import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6801de2c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "alreadyApplied"
}
const _hoisted_2 = { class: "ramp-job-description-icons" }
const _hoisted_3 = { class: "ramp-job-description-content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-white" }, " Fetching Jobs ", -1))
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "ramp-job-description-icons" }
const _hoisted_7 = { class: "float-right ramp-job-shares" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", { class: "mr-2" }, "SHARE", -1))
const _hoisted_9 = { class: "ramp-job-description-main-content" }
const _hoisted_10 = { id: "main-content" }
const _hoisted_11 = { class: "form-generated" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { class: "text-center" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-grey" }, " Checking for Job Openings ", -1))
const _hoisted_16 = { key: 1 }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, " Sorry, there are job openings as of the moment. ", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-grey" }, " Please do: try a different location or visit this page another time. ", -1))
const _hoisted_19 = { key: 0 }
const _hoisted_20 = {
  key: 0,
  class: "text-center text-success mb-2"
}
const _hoisted_21 = { key: 1 }
const _hoisted_22 = {
  key: 0,
  class: "text-center mt-2"
}
const _hoisted_23 = {
  key: 0,
  class: "text-success"
}
const _hoisted_24 = {
  key: 1,
  class: "text-red"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_btn_toggle = _resolveComponent("v-btn-toggle")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_DataPagination = _resolveComponent("DataPagination")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_overlay = _resolveComponent("v-overlay")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_text_field = _resolveComponent("v-text-field")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_container, { class: "text-left site-content-crowded px-8" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_sheet, { class: "d-flex align-center ramp-location-filter" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: "12",
              class: "py-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, { class: "mdi mdi-map-marker mr-3 no-mobile" }),
                _createVNode(_component_v_btn_toggle, {
                  modelValue: _ctx.selectedLocation,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedLocation) = $event)),
                  shaped: "",
                  variant: "text",
                  "selected-class": "ramp-location-toggle",
                  mandatory: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.locationFilter('all'))),
                      value: "all",
                      class: "loc-btn"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" All ")
                      ]),
                      _: 1
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locations, (location) => {
                      return (_openBlock(), _createBlock(_component_v_btn, {
                        class: "loc-btn",
                        key: location.id,
                        value: location.id,
                        onClick: ($event: any) => (_ctx.locationFilter(location.id))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(location.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["value", "onClick"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_container, { class: "text-left site-content-crowded px-8" }, {
      default: _withCtx(() => [
        (_ctx.jobs.length)
          ? (_openBlock(), _createBlock(_component_v_row, {
              key: 0,
              "no-gutters": ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  xl: "3",
                  md: "3",
                  class: _normalizeClass(_ctx.selectionOnMobile ? 'no-mobile' : 'normal')
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jobs, (job) => {
                      return (_openBlock(), _createBlock(_component_v_card, {
                        key: job.id,
                        ref_for: true,
                        ref: job.id,
                        class: _normalizeClass([{ 'ramp-job-items-active': _ctx.selectsJobItem(job.id) }, "mb-2 pa-2 rounded ramp-job-items"]),
                        onClick: ($event: any) => {_ctx.clickedJobItem(job.id);_ctx.selectionOnMobile=true;}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card_subtitle, { class: "ramp-job-title" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(job.title) + " ", 1),
                              (job.userAppliedThisJob)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
                                    _createVNode(_component_v_icon, { class: "mdi mdi-briefcase-check text-info" }),
                                    _createVNode(_component_v_tooltip, {
                                      activator: "parent",
                                      location: "top"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("Already applied for this position.")
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_v_card_text, null, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_2, [
                                _createVNode(_component_v_icon, { class: "mdi mdi-map-marker" }),
                                _createTextVNode(" " + _toDisplayString(job.territory.name), 1)
                              ]),
                              _createElementVNode("div", _hoisted_3, _toDisplayString(job.sub_title), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["class", "onClick"]))
                    }), 128)),
                    _createVNode(_component_DataPagination, {
                      totalItemsForPages: _ctx.totalItemsForPages,
                      perPage: _ctx.perPage,
                      visiblePages: 3,
                      onPaginationPageUpdate: _ctx.updatePage
                    }, null, 8, ["totalItemsForPages", "perPage", "onPaginationPageUpdate"]),
                    _createVNode(_component_v_overlay, {
                      modelValue: _ctx.listLoader,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.listLoader) = $event)),
                      class: "align-center justify-center"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", null, [
                          _createVNode(_component_v_progress_circular, {
                            indeterminate: "",
                            color: "blue",
                            size: 113,
                            width: 7
                          }),
                          _hoisted_4
                        ])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["class"]),
                _createVNode(_component_v_col, {
                  xl: "9",
                  md: "9",
                  class: _normalizeClass(!_ctx.selectionOnMobile ? 'no-mobile' : 'normal')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, { class: "ml-4 mb-10 pa-5 rounded-xl" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card_subtitle, { class: "ramp-job-title" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.selectedJobDetails.title) + " ", 1),
                            _createElementVNode("a", {
                              href: _ctx.jobItemLinks(_ctx.selectedJobDetails.slug),
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setLocalSlug(_ctx.selectedJobDetails.slug, _ctx.selectedJobDetails.id))),
                              target: "_blank",
                              class: "float-right ramp-job-new-tab no-mobile"
                            }, [
                              _createTextVNode(" Apply for this Job "),
                              _createVNode(_component_v_icon, { class: "mdi mdi-open-in-new" })
                            ], 8, _hoisted_5)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_card_text, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_6, [
                              _createVNode(_component_v_icon, { class: "mdi mdi-map-marker" }),
                              _createTextVNode(" " + _toDisplayString(_ctx.selectedJobDetails.territory?.name) + " ", 1),
                              _createElementVNode("span", _hoisted_7, [
                                _hoisted_8,
                                _createVNode(_component_v_icon, {
                                  class: "mdi mdi-content-copy mr-1 shareButtons",
                                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.shareJob('copy',_ctx.selectedJobDetails.slug)))
                                })
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_9, [
                              _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("div", _hoisted_11, [
                                  _createElementVNode("div", { innerHTML: _ctx.layout }, null, 8, _hoisted_12)
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_13, [
                              _createVNode(_component_v_btn, {
                                block: "",
                                class: "mb-1",
                                href: _ctx.jobItemLinks(_ctx.selectedJobDetails.slug),
                                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setLocalSlug(_ctx.selectedJobDetails.slug, _ctx.selectedJobDetails.id))),
                                color: "info"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, { class: "mdi mdi-briefcase" }),
                                  _createTextVNode(" Apply for this Job")
                                ]),
                                _: 1
                              }, 8, ["href"]),
                              _createVNode(_component_v_btn, {
                                block: "",
                                color: "warning",
                                class: "mobile-only",
                                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.selectionOnMobile=false))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, { class: "mdi mdi-arrow-left" }),
                                  _createTextVNode(" Back to List ")
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["class"])
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_v_row, {
              key: 1,
              "no-gutters": ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  xl: "12",
                  md: "12",
                  class: "text-center ma-10 pa-10"
                }, {
                  default: _withCtx(() => [
                    (_ctx.displayLoader)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          _createVNode(_component_v_progress_circular, {
                            indeterminate: "",
                            color: "blue-grey",
                            size: 113,
                            width: 7
                          }),
                          _hoisted_15
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          _createElementVNode("h1", null, [
                            _createVNode(_component_v_icon, { class: "mdi mdi-emoticon-sad-outline" })
                          ]),
                          _hoisted_17,
                          _hoisted_18
                        ]))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
      ]),
      _: 1
    }),
    _createVNode(_component_v_overlay, {
      "model-value": _ctx.shareModal,
      disabled: true,
      persistent: true,
      class: "align-center justify-center"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, {
          class: "overlay-content pa-5",
          width: "400"
        }, {
          default: _withCtx(() => [
            (_ctx.shareType === 'copy')
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _createElementVNode("h4", null, [
                    _createTextVNode(" Copy Url: "),
                    _createVNode(_component_v_icon, {
                      class: "mdi mdi-close float-right",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.shareModal=false))
                    })
                  ]),
                  _createVNode(_component_v_text_field, {
                    class: "pt-2 pb-2 mt-5",
                    value: _ctx.shareLink,
                    density: "compact"
                  }, {
                    append: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        size: "xl",
                        color: "info",
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.copyToClipboard()))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, { class: "mdi mdi-content-copy" })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value"]),
                  (_ctx.shareResult)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        _createVNode(_component_v_icon, { class: "mdi mdi-content-copy" }),
                        _createTextVNode(" Copied to Clipboard ")
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : (_ctx.shareType === 'mail')
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    _createElementVNode("h4", null, [
                      _createTextVNode(" Send to E-mail: "),
                      _createVNode(_component_v_icon, {
                        class: "mdi mdi-close float-right",
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.shareModal=false))
                      })
                    ]),
                    _createVNode(_component_v_text_field, {
                      label: "Name",
                      modelValue: _ctx.name,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.name) = $event)),
                      required: ""
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_v_text_field, {
                      label: "E-mail",
                      modelValue: _ctx.email,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.email) = $event)),
                      required: ""
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_v_btn, {
                      color: "light-blue",
                      block: "",
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.sendToEmail())),
                      loading: _ctx.emailLoader
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, { class: "mdi mdi-email-arrow-right" }),
                        _createTextVNode(" Send ")
                      ]),
                      _: 1
                    }, 8, ["loading"]),
                    (_ctx.shareResult)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          (_ctx.shareResult === 'emailed')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_23, [
                                _createVNode(_component_v_icon, { class: "mdi mdi-email-arrow-right" }),
                                _createTextVNode(" E-mail Sent ")
                              ]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_24, [
                                _createVNode(_component_v_icon, { class: "mdi mdi-alert" }),
                                _createTextVNode(" " + _toDisplayString(_ctx.shareResult), 1)
                              ]))
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model-value"])
  ], 64))
}